var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityfeed = function SvgActivityfeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "activityfeed_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".activityfeed_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11c0 .3-.2.5-.5.5H4c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h5c.3 0 .5.2.5.5zM11.5 5.5h3M11.5 8.5h3M11.5 11.5h3M3.5 14.5h11M3.5 17.5h11",
    className: "activityfeed_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 22.5h-17c-1.7 0-3-1.3-3-3v-17c0-.6.4-1 1-1h15c.6 0 1 .4 1 1v17c0 1.7 1.3 3 3 3s3-1.3 3-3v-15M20.5 4.5V20",
    className: "activityfeed_svg__st0"
  })));
};
export default SvgActivityfeed;